import '@chakra-ui/react';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, rem, Spinner, SpinnerProps } from '@bonusly/design-system';

interface SpacedSpinnerProps extends SpinnerProps {
	spacing?: string | number;
}

export const SpacedSpinner: FC<SpacedSpinnerProps> = ({ spacing = rem(44), ...rest }) => {
	const { t } = useTranslation('common');

	return (
		<Flex justifyContent="center" my={spacing}>
			<Spinner color="gray.400" data-testid="spinner" label={t('loading')} size="lg" {...rest} />
		</Flex>
	);
};
